import {
  SteeringWalletBasis,
  Wallet_Steering_Attribute,
  Wallet_Steering_Operator,
} from '@occc/graphql';
import { WalletSteeringFormValues } from '@occc-app/routes/Audience/types';

export const walletSteeringItemInitialValues: WalletSteeringFormValues = {
  wallet: undefined,
  dimension: Wallet_Steering_Attribute.Capacity,
  operator: Wallet_Steering_Operator.IsGreaterThan,
};

export const titleByDimension: Record<Wallet_Steering_Attribute, string> = {
  [Wallet_Steering_Attribute.Capacity]: 'Capacity',
  [Wallet_Steering_Attribute.Share]: 'Share',
  [Wallet_Steering_Attribute.Opportunity]: 'Opportunity',
  [Wallet_Steering_Attribute.PeriodShare]: 'Historic Share',
  [Wallet_Steering_Attribute.PeriodOpportunity]: 'Historic Opportunity',
};

export const titleByOperator: Record<Wallet_Steering_Operator, string> = {
  [Wallet_Steering_Operator.IsEqualTo]: 'Is equal to',
  [Wallet_Steering_Operator.IsGreaterThan]: 'Is greater than',
  [Wallet_Steering_Operator.IsGreaterThanOrEqualTo]: 'Is greater than or equal to',
  [Wallet_Steering_Operator.IsLessThan]: 'Is less than',
  [Wallet_Steering_Operator.IsLessThanOrEqualTo]: 'Is less than or equal to',
};

export const dimensionOptions = [
  Wallet_Steering_Attribute.Capacity,
  Wallet_Steering_Attribute.Share,
  Wallet_Steering_Attribute.Opportunity,
  Wallet_Steering_Attribute.PeriodShare,
  Wallet_Steering_Attribute.PeriodOpportunity,
].map((value) => ({
  label: titleByDimension[value],
  value,
}));

export const operatorOptions = [
  Wallet_Steering_Operator.IsEqualTo,
  Wallet_Steering_Operator.IsGreaterThan,
  Wallet_Steering_Operator.IsGreaterThanOrEqualTo,
  Wallet_Steering_Operator.IsLessThan,
  Wallet_Steering_Operator.IsLessThanOrEqualTo,
].map((value) => ({
  label: titleByOperator[value],
  value,
}));

export const walletConfigurationBasisToLabelMap: Record<SteeringWalletBasis, string> = {
  [SteeringWalletBasis.Daily]: ' per day',
  [SteeringWalletBasis.Weekly]: ' per week',
  [SteeringWalletBasis.Monthly]: ' per month',
};
